if (!customElements.get('steps-in-viewport')) {
  customElements.define(
    'steps-in-viewport',
    class StepsInViewport extends HTMLElement {
      constructor () {
        super();
        this.device = this.getAttribute('data-enable-on');
        this.container = this.querySelector('.scrollable-container');
        this.disabled = [];
        const steps = this.container.querySelectorAll('.step-thumbnail__item');
        steps.forEach((item) => {
          const form = item.querySelector('form[action="/cart/add"]');
          if (form) {
            form.addEventListener('submit', (event) => {
              const root = event.target.closest('.step-thumbnail__item');
              if (root) {
                const id = root.id;
                if (!this.disabled.includes(id)) {
                  this.disabled.push(id);
                }
                if (!item.classList.contains('active')) {
                  root.classList.add('active');
                }
              }
            });
          }
        });

        window.addEventListener('scroll', () => {
          if (this.isVisible(this.container)) {
            steps.forEach((item, key) => {
              if (this.disabled.includes(item.id)) {
                return;
              }
              if (this.isScrollWithinElementAndElementInView(item, item) &&
                (this.device === 'all' || this.device === 'mobile' && this.isMobile())) {
                if (!item.classList.contains('active')) {
                  item.classList.add('active');
                  steps.forEach((step) => {
                    if (step !== item && !this.disabled.includes(step.id)) {
                      setTimeout(() => {
                        step.classList.remove('active');
                      }, 5);
                    }
                  });

                }
              }
            });
          }
        });
      }

      isMobile () {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      isVisible (el) {
        const { top, bottom } = el.getBoundingClientRect();
        const vHeight = (window.innerHeight || document.documentElement.clientHeight);

        return (
          (top > 0 || bottom > 0) &&
          top < vHeight
        );
      }

      isScrollWithinElementAndElementInView (targetElement, offsetElement) {
        const rect = targetElement.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        // Determine the height of the offset element
        const offsetHeight = offsetElement ? offsetElement.offsetHeight : 0;

        // Check if the target element is in the viewport
        const isInViewport = (rect.top - offsetHeight) < windowHeight && (rect.bottom - offsetHeight) >= 0;

        // Check if the current scroll position is within the target element's height, considering the offset
        const scrollPosition = window.scrollY || document.documentElement.scrollTop;
        const elementTopRelativeToDocument = rect.top + scrollPosition - offsetHeight;
        const elementBottomRelativeToDocument = elementTopRelativeToDocument + rect.height;
        const isScrollWithinElement = scrollPosition >= elementTopRelativeToDocument && scrollPosition <
          elementBottomRelativeToDocument;

        return isInViewport && isScrollWithinElement;
      }
    },
  );
}
